import React from 'react'
import styled, { css } from 'styled-components'
import { LEGAL_COPY } from '../constants'

interface LegalCopyProps {
  bottom?: boolean
}

const LegalText =
  styled.small <
  LegalCopyProps >
  `
  font-size: 11px;
  line-height: 15px;
  margin: 15px 0 20px 0;
  color: #999;
  display: block;
  text-align: left;
  padding-bottom: 32px;

  ${({ bottom }) =>
    bottom &&
    css`
      position: absolute;
      bottom: 0;
      padding: 0 30px 32px; 30px;
    `}
`

export const LegalCopy: React.FC<LegalCopyProps> = ({ bottom }) => <LegalText bottom={bottom}>{LEGAL_COPY}</LegalText>
